import { AsyncButton, Button } from '@components/button';
import { Form, FormTextInput } from '@components/form';
import { useInviteRemoteDevelopmentMutation } from '@generated/UseGraphqlHooks';
import { Stack } from '@mui/material';
import * as yup from 'yup';

const validationSchema = yup.object({
  email: yup.string().email('Invalid email').required('Email is required'),
});

export const ShareRemoteSessionModal = ({
  editorSessionId,
  onClose,
}: {
  editorSessionId: string;
  onClose: VoidFunction;
}) => {
  const [inviteSession] = useInviteRemoteDevelopmentMutation();
  const handleFormSubmit = (values: { email: string }) => {
    inviteSession({ variables: { editorSessionId, email: values.email } });
    onClose();
  };
  return (
    <Form
      initialValues={{
        email: '',
      }}
      validationSchema={validationSchema}
      onSubmit={handleFormSubmit}
      validateOnBlur={false}
      validateOnChange={true}
    >
      {({ isValid, handleSubmit, dirty, isSubmitting }) => {
        return (
          <Stack>
            <FormTextInput name="email" label="Email" type="email" />
            <Stack gap={4}>
              <AsyncButton
                fullWidth
                loading={isSubmitting}
                disabled={!(isValid && dirty && !isSubmitting)}
                onClick={handleSubmit}
                data-cy="New-Workspace-Modal-Create-Button"
              >
                Invite
              </AsyncButton>
              <Button
                fullWidth
                variant="secondary"
                data-cy="New-Workspace-Modal-Cancel-Button"
                onClick={onClose}
              >
                Cancel
              </Button>
            </Stack>
          </Stack>
        );
      }}
    </Form>
  );
};
